import { BoneModal } from './BoneModal';

export function initFindYourLocationModal() {
	const elem = document.getElementById('gr-find-your-location');
	if (!elem) {
		return;
	}

	const modal = new BoneModal(elem);
	if (!modal) {
		return;
	}

	if (modal.elem) {
		const content = modal.elem.querySelector('.find-location-modal-content');
		if (content) {
			// click delegate
			content.addEventListener('click', (e) => {
				if (e.target.tagName.toUpperCase() === 'A') {
					modal.close();
				}
			});
		}
	}

	// click delegate to handle # links
	document.body.addEventListener('click', (e) => {
		if (e.target.tagName.toUpperCase() === 'A') {
			const url = new URL(e.target.href);
			if (url && url.hash === '#gr-find-your-location') {
				e.preventDefault();
				e.stopImmediatePropagation();
				modal.open();
			}
		}
	});
}



// export function unloadModuleModals() {
// 	if (instances.length) {
// 		instances.forEach(instance => {
// 			instance.destroy();
// 		})
// 	}

// 	instances = [];
// }



// WEBPACK FOOTER //
// ./scripts/modules/find-your-location.js